import type { CardDef, CardDefId, CardIid, WonderDef, WonderId, WonderStageDef } from '../types/cards';
import type { Age, WonderSide } from '../types/resources';
import { AGE1_CARDS } from './age1';
import { AGE2_CARDS } from './age2';
import { AGE3_CARDS } from './age3';
import { GUILD_CARDS } from './guilds';
import { WONDERS } from './wonders';

export const ALL_CARDS: readonly CardDef[] = [...AGE1_CARDS, ...AGE2_CARDS, ...AGE3_CARDS, ...GUILD_CARDS];

const CARD_BY_ID = new Map<CardDefId, CardDef>(ALL_CARDS.map((c) => [c.id, c]));
const WONDER_BY_ID = new Map<WonderId, WonderDef>(WONDERS.map((w) => [w.id, w]));

export const WONDER_IDS: readonly WonderId[] = WONDERS.map((w) => w.id);

export function getCard(id: CardDefId): CardDef {
  const c = CARD_BY_ID.get(id);
  if (!c) throw new Error(`Carta desconocida: ${id}`);
  return c;
}

export function hasCard(id: string): boolean {
  return CARD_BY_ID.has(id);
}

export function getWonder(id: WonderId): WonderDef {
  const w = WONDER_BY_ID.get(id);
  if (!w) throw new Error(`Maravilla desconocida: ${id}`);
  return w;
}

export function getStages(id: WonderId, side: WonderSide): WonderStageDef[] {
  return getWonder(id).sides[side].stages;
}

/** `lumber_yard:1:4` → `lumber_yard`. */
export function defIdOf(iid: CardIid): CardDefId {
  const i = iid.indexOf(':');
  return i === -1 ? iid : iid.slice(0, i);
}

export function cardOf(iid: CardIid): CardDef {
  return getCard(defIdOf(iid));
}

export function makeIid(def: CardDef, age: Age, minPlayers: number): CardIid {
  return def.guild ? `${def.id}:3:g` : `${def.id}:${age}:${minPlayers}`;
}

/** Cartas (no gremios) de una era para N jugadores, como iids. */
export function ageDeckFor(age: Age, players: number): CardIid[] {
  const out: CardIid[] = [];
  for (const def of ALL_CARDS) {
    if (def.guild) continue;
    for (const copy of def.copies) {
      if (copy.age === age && copy.minPlayers <= players) out.push(makeIid(def, age, copy.minPlayers));
    }
  }
  return out;
}

export function guildIids(): CardIid[] {
  return GUILD_CARDS.map((g) => makeIid(g, 3, 3));
}
